import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import {BaseTypedValueType, TypedValue} from 'notebook/tables/TableConstants';
import ReagentChip from 'samples/plate-maps/fill-plate-modal/ReagentChip';
import {FrozenEntityChipData} from 'samples/plate-maps/plate-record/PlateRecordConstants';
import {ReagentAssignmentGroup, TestOrderInfoById} from 'samples/plate-maps/PlateMapConstants';
import {ChipSize} from 'ui-library/chips/Chip';

interface FillPlateTransferSourceChipProps {
  typedValue: TypedValue;
  frozenEntityChipData?: {[id: string]: FrozenEntityChipData};
  reagentGroupsById: {[id: string]: ReagentAssignmentGroup};
  testOrderInfoById: TestOrderInfoById;
}

export default function FillPlateTransferSourceChip({
  typedValue,
  frozenEntityChipData,
  reagentGroupsById,
  testOrderInfoById,
}: FillPlateTransferSourceChipProps): JSX.Element | null {
  if (typedValue.type === BaseTypedValueType.JSON) {
    const {reagent} = typedValue.jsonValue;
    if (reagent == null) {
      return <div className={css(styles.emptyWell)}>Empty well</div>;
    } else {
      return (
        <ReagentChip
          chipSize={ChipSize.TABLE_CELL}
          reagent={reagent}
          reagentGroupsById={reagentGroupsById}
          frozenChipDisplayOverrides={frozenEntityChipData}
          testOrderInfoById={testOrderInfoById}
        />
      );
    }
  }
  return null;
}

const styles = StyleSheet.create({
  emptyWell: {
    fontStyle: 'italic',
  },
});
